<template>
  <RevButton :disabled :loading variant="primary" @click="emit('next')">
    {{ i18n(translations.buttonCheckout) }}
  </RevButton>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'

import translations from './CheckoutButton.translations'

const i18n = useI18n()

defineProps<{
  loading: boolean
  disabled: boolean
}>()

const emit = defineEmits(['next'])
</script>
